import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from "./languages";

const app = createApp(App);

app.use(ElementPlus);
app.use(store);
app.use(router);
app.use(i18n);
app.mount('#app')
